import React, { createContext, useContext, useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';

interface ErrorSnackbarContextProps {
    showError: (message: string) => void;
}

const ErrorSnackbarContext = createContext<ErrorSnackbarContextProps | undefined>(undefined);

const ErrorSnackbarProvider: React.FC = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');

    const showError = (errorMessage: string) => {
        setMessage(errorMessage);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <ErrorSnackbarContext.Provider value={{ showError }}>
            {children}
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <MuiAlert onClose={handleClose} severity="error">
                    {message}
                </MuiAlert>
            </Snackbar>
        </ErrorSnackbarContext.Provider>
    );
};

function useErrorSnackbar() {
    const context = useContext(ErrorSnackbarContext);
    if (!context) {
        throw new Error('useErrorSnackbar must be used within an ErrorSnackbarProvider');
    }
    return context;
}

export { ErrorSnackbarProvider, useErrorSnackbar };
